import { render, staticRenderFns } from "./trade_profit.vue?vue&type=template&id=59c9ccc9&scoped=true"
import script from "./trade_profit.vue?vue&type=script&lang=js"
export * from "./trade_profit.vue?vue&type=script&lang=js"
import style0 from "./trade_profit.vue?vue&type=style&index=0&id=59c9ccc9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c9ccc9",
  null
  
)

export default component.exports